import React from 'react';
import { sentryEnabled } from '../sentryInit';

interface ErrorBoundaryState { hasError: boolean; info?: string; }

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };
  static getDerivedStateFromError(err: any): ErrorBoundaryState { return { hasError: true, info: err?.message }; }
  componentDidCatch(error: any, info: any) {
    // eslint-disable-next-line no-console
    console.error('Runtime error boundary caught:', error, info?.componentStack);
    // Hook for telemetry
    (window as any).__appTelemetryQueue = (window as any).__appTelemetryQueue || [];
    (window as any).__appTelemetryQueue.push({ t: Date.now(), type: 'error', error: String(error) });
    // Rapportera till Sentry när den är aktiv (samma dynamiska import som i
    // sentryInit.ts, så SDK:n inte hamnar i huvudbundlen).
    if (sentryEnabled) {
      import('@sentry/react')
        .then((Sentry) => Sentry.captureException(error, { extra: { componentStack: info?.componentStack } }))
        .catch(() => {});
    }
  }
  render(){
    if(this.state.hasError){
      // Use hardcoded strings to avoid crash-loop if i18n provider is broken
      return (
        <div style={{ padding: 32, fontFamily:'system-ui', color:'#222', textAlign: 'center' }}>
          <h1>Något gick fel</h1>
          <p>Ett oväntat fel inträffade. Ladda om sidan för att försöka igen.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: 16, padding: '10px 24px', fontSize: 16, cursor: 'pointer', borderRadius: 8, border: '1px solid #ccc', background: '#f5f5f5' }}
          >
            🔄 Ladda om
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
